import {noop} from '@Utils/general.util';
import type {DeepPartial} from "@/global";

export const asyncSleep = (time: number): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
};

export const debounce = <T extends (...args: any[]) => any>(func: T, wait: number, onStart: () => void = noop): T => {
  let timeoutId: number | undefined;
  let isDebouncing = false;

  return function (this: any, ...args: any[]) {
    if (!isDebouncing) {
      onStart();
      isDebouncing = true;
    }

    clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      func.apply(this, args);
      isDebouncing = false;
    }, wait);
  } as T;
};

function isPlainObject(v: unknown): v is Record<string, unknown> {
  return typeof v === "object" && v !== null && !Array.isArray(v);
}

export function deepAssign<T extends Record<string, unknown>>(
  target: T,
  source: DeepPartial<T>
): void {
  if (!isPlainObject(source)) return;

  for (const key of Object.keys(source) as (keyof T)[]) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const sVal = source[key];
    if (sVal === undefined) continue;

    const tVal = target[key];

    if (Array.isArray(sVal)) {
      (target as Record<keyof T, unknown>)[key] = sVal as unknown;
      continue;
    }

    if (isPlainObject(sVal) && isPlainObject(tVal)) {
      deepAssign(tVal as Record<string, unknown>, sVal);
    } else {
      (target as Record<keyof T, unknown>)[key] = sVal as unknown;
    }
  }
}



export enum EditorType {
  EMAIL,
  DESIGN,
  WEBSITE,
  FORM,
}
